import CachedDictionary from '../../../services/engines/CachedDictionary';

// Board items keyed by rk, grouped by parentRK (= board rk)
class BoardItemCache extends CachedDictionary {
    _name = 'BoardItemCache';

    /**
     * @param {string} parentRK - board rk
     * @returns {object[]}
     */
    getByParent = (parentRK) => this.getKeys().map((k) => this.getKey(k)).filter((x) => x.parentRK === parentRK);

    /**
     * Replaces all items of one board — items moved to another board disappear.
     * @param {string} parentRK
     * @param {object[]} items
     */
    replaceForParent = (parentRK, items) => {
        this.getByParent(parentRK).forEach((x) => delete this._data[x.rk]);
        items.forEach((x) => this.setKey(x.rk, x));
    };

    /**
     * @param {string} rk
     */
    remove = (rk) => {
        delete this._data[rk];
    };
}

const boardItemCache = new BoardItemCache();
export default boardItemCache;
